import React from "react";
import { ShieldCheckIcon } from "@heroicons/react/solid";
import { ButtonBase } from "@reusejs/react";
import { useRouter } from "next/router";

export default function PanPreview(props: any) {
  const router = useRouter();
  return (
    <div className="w-full mt-8">
      <div className="w-full flex justify-between items-center">
        <div>
          <label className="block text-sm font-medium text-gray-800">
            <span className="font-bold"> Verified Document: </span>
            PAN ({props.kycData?.pan_data?.document_type})
          </label>
        </div>
        {process.env.NEXT_PUBLIC_APP_NAME === "banker" && (
          <div>
            <ButtonBase
              variant="primary"
              type="button"
              label="Download Document"
              onClick={() =>
                router.push(
                  `${props.kycData?.pan_data?.front}&dl=pan`,
                  undefined,
                  { shallow: true }
                )
              }
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-blue-600 hover:bg-blue-700",
                textColor: "text-white",
                border: "any",
                padding: "px-4 py-3",
              }}
            />
          </div>
        )}
      </div>
      {props.kycData?.pan_data?.front && (
        <div className="my-6">
          <label className="block text-sm font-medium text-gray-800 mb-4">
            Front
          </label>
          <div className="h-48 w-72 sm:w-80 cursor-pointer">
            <img
              className="h-full w-full rounded-md object-cover"
              src={`${props.kycData?.pan_data?.front}`}
            />
          </div>
        </div>
      )}

      <div className="flex items-center">
        <ShieldCheckIcon className="h-6 w-6 text-green-500 mr-2" />
        <label className="block text-sm font-bold text-gray-800">
          PAN Verified
        </label>
      </div>
    </div>
  );
}
